import { useQuery, UseQueryResult } from 'react-query';
import { ErrorWithData } from 'task-manager/bench-services-api/ErrorWithData';
import { BusinessService } from '../types';

async function get(apiUrl: string, addOnId: string): Promise<BusinessService | undefined> {
  if (!apiUrl) throw new Error('Required properties are not set');
  if (!addOnId) return;

  const response: Response = await fetch(`${apiUrl}/add-on/${addOnId}/business-service`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    const error = (await response.json()) as Record<string, unknown>;
    throw new ErrorWithData('Failed to get business service', error);
  }
  return (await response.json()) as BusinessService | undefined;
}

interface UseFetchBusinessServiceProps {
  addOnId?: string;
}

export const useFetchBusinessService = ({
  addOnId,
}: UseFetchBusinessServiceProps): UseQueryResult<BusinessService | undefined> => {
  const apiUrl = window.BENCH?.auApi?.SETUP_BUSINESS_SERVICE_API_URL || '';

  return useQuery({
    queryKey: ['getBusinessService', { addOnId }],
    queryFn: () => {
      if (!addOnId) {
        return Promise.resolve(undefined);
      }
      return get(apiUrl, addOnId);
    },
    retry: false,
  });
};
